import { fork } from 'redux-saga/effects';
import { watchLoadCommon } from "./sagas/bootstrapCommon";
import { watchCreateSupportTicket } from "./sagas/createSupportTicketSaga";
import { watchDeleteLocation } from "./sagas/deleteStudioLocationSaga";
import { watchDisableArtistInfo } from "./sagas/disableArtistInfo";
import { watchReloadArtists } from "./sagas/reloadArtists";
import { watchReloadStudio } from "./sagas/reloadStudio";
import { watchSaveStudioLocation } from "./sagas/saveLocationSaga";
import { watchUpdateStudio } from "./sagas/updateStudio";
import { watchReloadTermintypen } from './sagas/reloadTermintypen';

const commonSagas = [fork(watchLoadCommon), fork(watchReloadArtists)
    , fork(watchDisableArtistInfo)
    , fork(watchReloadStudio), fork(watchUpdateStudio)
    , fork(watchDeleteLocation), fork(watchSaveStudioLocation), fork(watchCreateSupportTicket), fork(watchReloadTermintypen)]

export default commonSagas
